// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1PVuj","buttons":"Footer_buttons__1jX__"};